import {
  ClusterType,
  SortingStrategy,
} from '../../clustering/clustering.types';
import { RestingDisplay } from '../../resting/resting.util';

export interface LayoutState {
  ilrImage: {
    hasImage: boolean;
    loaded: boolean;
  };
  showParentHRPlot: boolean;
  showHrInBpm: boolean;
  sortingStrategy: SortingStrategy;
  filterOption: FilterOption;
  gain: number;
  display: RestingDisplay;
  showDelineation: boolean;
  lead: string;
  withDiagnosticGroup: boolean;
  withSuggestionsPanel: boolean;
  withComputedMetrics: boolean;
  withPatientInfo: boolean;
}

export type FilterOption = ClusterType | 'All';
export const BPM = 'bpm';
export const MS = 'ms';
export const DEGREE = '°';
